import { ISchoolFeedUrlQueries } from "../../../utils/SchoolBlocksUtilities";
import SchoolFeedMonthCalendar from "../SchoolFeedMonthCalendar";
import { IView } from "../../../stores/InterfaceStore";
import { NewsWidget } from "./NewsWidget";
import { useStores } from "../../../stores/useStores";

export default function CalendarWidget(props: {
  urlQuery: ISchoolFeedUrlQueries;
  initialEventsPromise: any;
}) {
  const { interfaceStore } = useStores();
  return (
    <div>
      <SchoolFeedMonthCalendar
        initialEventsPromise={props.initialEventsPromise}
        urlQuery={props.urlQuery}
      />
      {(props.urlQuery.type === "events" ||
        (interfaceStore.view !== IView.DEFAULT &&
          interfaceStore.view !== IView.SCHOOLFEED_PAGE)) && <NewsWidget />}
    </div>
  );
}
